function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.166.254h79.668v79.668H.166z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.863 18.997c3.964-1.062 8.63 2.248 12.19 6.538-1.777 4.016-2.827 8.334-2.827 11.565 0 4.13 1.714 7.858 4.468 10.515a12.661 12.661 0 01-5.368 2.966c-6.792 1.82-13.773-2.211-15.593-9.003-1.82-6.792.338-20.761 7.13-22.581zm35.909 6.45c3.55-4.247 8.18-7.505 12.116-6.45 6.792 1.82 8.95 15.789 7.13 22.58-1.82 6.793-8.801 10.824-15.593 9.004a12.676 12.676 0 01-5.414-3.007A14.558 14.558 0 0054.438 37.1c0-3.213-1.038-7.5-2.796-11.496z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.832 51.706c8.067 0 14.606-6.54 14.606-14.606 0-8.066-6.54-22.904-14.606-22.904-8.066 0-14.606 14.838-14.606 22.904 0 8.067 6.54 14.606 14.606 14.606z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.78 23.988l-.163 1.88a5.2 5.2 0 011.575.55c.495.278.926.59 1.294.94l.134.129-.102.155-.562.856c-.1.144-.205.255-.314.334a.75.75 0 01-.446.135c-.13 0-.27-.038-.424-.11-.13-.06-.279-.133-.446-.218-.16-.082-.338-.166-.533-.252a3.253 3.253 0 00-.374-.136l-.289 3.428c.394.124.784.259 1.17.405.457.172.87.395 1.238.67.376.28.681.63.914 1.046.237.426.354.95.354 1.572 0 .606-.1 1.177-.303 1.71-.203.536-.5 1.01-.89 1.42a4.49 4.49 0 01-1.435.999 5.539 5.539 0 01-1.74.442l-.096 1.188a.886.886 0 01-.244.529.788.788 0 01-.602.253h-1.089l.17-2.033a7.201 7.201 0 01-1.9-.586 6.002 6.002 0 01-1.688-1.156l-.131-.13.102-.152.708-1.056a.95.95 0 01.321-.298.855.855 0 01.432-.119c.182 0 .367.062.555.179.157.097.336.212.536.344.192.126.412.253.66.38.175.09.376.163.603.219l.317-3.755a14.604 14.604 0 01-1.153-.396 4.607 4.607 0 01-1.223-.702 3.327 3.327 0 01-.894-1.125c-.228-.458-.34-1.021-.34-1.689 0-.503.1-.995.301-1.474.201-.48.493-.908.874-1.283.38-.375.847-.683 1.4-.924a5.185 5.185 0 011.701-.4l.086-.985a.875.875 0 01.246-.537.795.795 0 01.6-.247h1.09zm-.866 10.326l-.269 3.221c.475-.1.836-.286 1.09-.554.298-.315.447-.729.447-1.254 0-.205-.035-.38-.104-.526a1.262 1.262 0 00-.302-.402 2.072 2.072 0 00-.485-.32 4.995 4.995 0 00-.377-.165zm-1.364-6.119a2.74 2.74 0 00-.545.16 1.726 1.726 0 00-.529.335 1.17 1.17 0 00-.287.42 1.376 1.376 0 00-.092.504c0 .206.034.384.102.535.069.154.165.291.29.412.132.126.289.24.471.34.11.06.227.117.35.17l.24-2.876z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.702 40.424c-3.89 14.44-19.368 25.229-37.87 25.229S5.852 54.864 1.962 40.424c3.89 3.91 19.368 6.832 37.87 6.832 18.434 0 33.867-2.9 37.827-6.789l.043-.043z",
  stroke: "#371447",
  fill: "#6D4C41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.697 38.777c.237-1.006-2.045-1.347-6.846-1.023-.526.831-.941 2.796-1.247 5.894 2.197-.888 3.89-1.494 5.077-1.816 1.188-.323 2.193-1.34 3.016-3.055z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.476 51.877c11.32 1.01 19.59 2.125 24.814 3.348 5.223 1.222 12.553 3.758 21.991 7.606",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.268 46.526c-7.323 1.63-13.39 3.63-18.202 5.999-4.81 2.369-9.643 5.625-14.495 9.77",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.768 47.143c5.17 2.88 9.8 4.984 13.887 6.312 4.087 1.328 9.554 2.504 16.401 3.528",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.214 44.867c-1.024 3.345-2.222 6.092-3.593 8.241-1.371 2.15-3.88 5.211-7.527 9.186m-17.926 3.32c-6.437-3.95-11.047-7.127-13.831-9.533-2.784-2.406-5.919-5.923-9.405-10.55",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.04 53.497c-1.478-1.57-2.83-2.814-4.056-3.734-1.227-.92-3.195-2.165-5.903-3.735",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.013 38.893c-.238-1.006 2.044-1.348 6.845-1.024.526.832.942 2.796 1.248 5.894-2.198-.888-3.89-1.493-5.078-1.816-1.188-.322-2.193-1.34-3.015-3.054z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 38.659 15.153)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 37.06 15.704)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 35.462 16.254)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 33.863 16.805)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 32.264 17.355)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 117.831 6.257)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 120.663 14.482)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 123.495 22.707)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 126.327 30.931)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 129.16 39.156)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 0.996,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 3.651,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.996,
  cy: 5.643,
  r: 1
}))));

function SvgRetirementLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRetirementLg;